export const MAPBOX_STYLES = ['open-street-map'];

export const COLOUR_SCALE_PALETTES = [
  [
    ['0.00', 'rgb(0, 0, 128)'],
    ['0.50', 'rgb(78, 126, 255)'],
    ['1.00', 'rgb(135, 206, 250)']
  ],
  [
    ['0.00', 'rgb(32, 93, 152)'],
    ['0.03', 'rgb(60, 90, 157)'],
    ['0.07', 'rgb(81, 85, 162)'],
    ['0.10', 'rgb(110, 85, 167)'],
    ['0.14', 'rgb(135, 85, 173)'],
    ['0.17', 'rgb(161, 85, 176)'],
    ['0.21', 'rgb(184, 86, 165)'],
    ['0.24', 'rgb(201, 85, 149)'],
    ['0.28', 'rgb(217, 84, 137)'],
    ['0.31', 'rgb(233, 83, 124)'],
    ['0.34', 'rgb(244, 87, 111)'],
    ['0.38', 'rgb(248, 106, 95)'],
    ['0.41', 'rgb(252, 129, 84)'],
    ['0.45', 'rgb(255, 150, 71)'],
    ['0.48', 'rgb(255, 169, 59)'],
    ['0.52', 'rgb(255, 170, 50)'],
    ['0.55', 'rgb(255, 155, 47)'],
    ['0.59', 'rgb(254, 140, 43)'],
    ['0.62', 'rgb(252, 123, 41)'],
    ['0.66', 'rgb(250, 106, 37)'],
    ['0.69', 'rgb(246, 93, 36)'],
    ['0.72', 'rgb(241, 82, 37)'],
    ['0.76', 'rgb(236, 71, 38)'],
    ['0.79', 'rgb(231, 61, 38)'],
    ['0.83', 'rgb(226, 50, 39)'],
    ['0.86', 'rgb(220, 40, 39)'],
    ['0.90', 'rgb(214, 30, 40)'],
    ['0.93', 'rgb(208, 20, 42)'],
    ['0.97', 'rgb(202, 10, 44)'],
    ['1.00', 'rgb(196, 0, 49)']
  ],
  [
    ['0.00', 'rgb(13, 8, 135)'],
    ['0.10', 'rgb(65, 4, 157)'],
    ['0.20', 'rgb(105, 0, 168)'],
    ['0.30', 'rgb(142, 12, 164)'],
    ['0.40', 'rgb(174, 40, 146)'],
    ['0.50', 'rgb(201, 68, 122)'],
    ['0.60', 'rgb(222, 97, 100)'],
    ['0.70', 'rgb(240, 127, 79)'],
    ['0.80', 'rgb(251, 161, 57)'],
    ['0.90', 'rgb(253, 198, 39)'],
    ['1.00', 'rgb(243, 240, 39)']
  ]
];